import { REGEX } from 'utils/constants';

export function isValidLink(match: string): boolean {
  const MIN_LENGTH = 8;
  const fileLikeRegex = /^\w+\.(png|jpeg|jpg|mp3|mp4|mov|pdf|docx?|xlsx?|txt|svg|webp|html)$/;

  return [
    !match.endsWith('.'),
    !REGEX.ALL_NUMERIC.test(match.replace(/\./g, '')),
    !fileLikeRegex.test(match),
    match.length >= MIN_LENGTH,
  ].every(Boolean);
}

export function validateHasLink(text: string): boolean {
  const matches = text.match(REGEX.LINK);

  if (!matches) return false;

  const validMatches = matches.filter(isValidLink);

  return !!validMatches.length;
}
